import { Box } from '@mui/material';
import Stack from '@mui/material/Stack';

import Tile from './Tile';

import type { TileType } from './types';

const stackSx = { width: '100%', gridColumn: { lg: 'span 2' }, flexWrap: 'wrap' };
const tileBoxSx = {
  width: { xs: 'calc(100% - 18px)', sm: 'calc(50% - 18px)', lg: 'calc(25% - 18px)' },
  minWidth: 230
};

const Tiles = ({ tiles }: { tiles: TileType[] }) => {
  return (
    <Stack
      useFlexGap
      className='highlighted-prices__container'
      direction='row'
      spacing={{ xs: 2, sm: 3 }}
      sx={stackSx}
    >
      {!!tiles.length &&
        tiles.map(tile => {
          return (
            <Box
              key={tile.id}
              id={tile.id}
              sx={tileBoxSx}
            >
              <Tile tile={tile} />
            </Box>
          );
        })}
    </Stack>
  );
};

export default Tiles;
